export default "__VITE_ASSET__I7chyvA6__"